<script setup lang="ts">
import type { IconOptions, VueClass } from '@/kasten-components/types';
import { cnMerge } from '@/utils/utils.js';

import { selectIconSlotVariants } from './select-variants';

export type KaSelectIconSlotProps = {
  class?: VueClass;
  iconOptions?: IconOptions;
};

const props = withDefaults(defineProps<KaSelectIconSlotProps>(), {
  class: '',
  iconOptions: undefined,
});

// `any` return type on purpose: Vue ignores a `defineSlots` entry's return type, and `VNode | VNode[]`
// makes vue-tsc recursively expand VNode's self-referential children type until it can trip TS2589.
defineSlots<{
  default?(): any;
}>();
</script>
<template>
  <span :class="cnMerge(selectIconSlotVariants(), props.class)" aria-hidden="true">
    <slot>
      <component
        :is="props.iconOptions?.icon"
        v-if="props.iconOptions?.icon"
        :class="cnMerge('size-3.5', props.iconOptions?.classes)"
      />
    </slot>
  </span>
</template>
